import api from './api';

export default {
  getBusinessTypes() {
    return new Promise((resolve, reject) => {
      api
        .get('business-type', {
          params: {
            orderby: 'name,asc'
          }
        })
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  }
};
